import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_medicalDevices: {
         confirm: 'Zatwierdź',
         connectionWithNfzFailedLoginInformationIncorrect:
            'Połączenie z systemem NFZ nie powiodło się. Podane dane logowania są nieprawidłowe.',
         deviceOrderApproveSuccess: 'Zlecenie zostało wystawione.',
         documentVerificationIssues: 'Problemy weryfikacji dokumentu:',
         draftFetchingErrorOccurred: 'Wystąpił błąd pobierania wersji roboczej zlecenia',
         draftFormExistsMessage:
            'W widoku eZWM istnieje niedokończony formularz. Czy na pewno chcesz zatwierdzić wizytę i utracić te dane?',
         draftFormExistsTitle: 'Istnieje niedokończony formularz',
         draftSaveErrorMessage:
            'Nie mogliśmy zapisać danych zlecenia, czy chcesz przejść dalej? \nNiezapisane dane zostaną utracone.',
         draftSaveErrorTitle: 'Błąd zapisu wersji roboczej zlecenia.',
         draftSaved: 'Wersja robocza zlecenia została zapisana.',
         ezwmAccountBlocked: 'Konto jest zablokowane w systemie eZWM. Spróbuj ponownie za 15 minut.',
         ezwmSuccesfullySent: 'eZWM zostało pomyślnie wysłane. Kod {{pin}}',
         fields: {
            additionalEntitlement: 'Uprawnienie dodatkowe',
            additionalIndications: 'Dodatkowe wskazania',
            additionalInformation: 'Dodatkowe informacje',
            allOptions: 'Wszystkie opcje',
            chooseAtLeastOneCriteria: 'Wybierz przynajmniej jedno kryterium',
            choosePlacementFirst: 'Najpierw wybierz umiejscowienie.',
            code: 'Kod',
            continuation: 'Kontynuacja',
            criteriaName: 'Nazwa kryterium',
            deviceAwardCriteria: 'Kryteria przyznania wyrobu',
            deviceType: 'Typ wyrobu',
            diagnosis: 'Rozpoznanie',
            fillAdditionalInformation: 'Uzupełnij dodatkowe informacje...',
            fillCodeOrCriteriaName: 'Uzupełnij kod lub nazwę kryterium...',
            fillDeviceTimeSpanShorteningJustification: 'Uzupełnij uzasadnienie dla skrócenia okresu użytkowania...',
            fillDiseaseCodeOrName: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
            firstSupplyMonth: 'Pierwszy miesiąc zaopatrzenia',
            fistulaCount: 'Liczba przetok',
            fistulaMinMaxValidationMessage: 'Wpisz cyfrę od 1 do 9 lub zostaw pole puste.',
            fistulaType: {
               COLOSTOMY: 'Kolostomia',
               ILEOSTOMY: 'Ileostomia',
               OTHER: 'Inna stomia',
               UROSTOMY: 'Urostomia',
               fistulaType: 'Rodzaj przetoki',
            },
            fistulaTypeRequired: 'Wymagane zaznaczenie rodzaju przetoki.',
            itemsCount: 'Liczba sztuk',
            itemsPerMonthCount: 'Liczba sztuk na miesiąc',
            justification: 'Uzasadnienie',
            leftSided: 'Lewostronne',
            medicalDevice: 'Wyrób medyczny',
            otherDeviceType: 'Inny wyrób medyczny',
            placement: 'Umiejscowienie',
            pregnantWoman: 'Kobieta w ciąży',
            refundLimitMultiplicity: 'Krotność limitu finansowania',
            refundLimitMultiplicityInfo:
               'W przypadku pacjentów z uprawnieniami dodatkowymi 47DN, 47ZN, 47ZND można wpisać wartość większą od 1 z dokładnością do jednego miejsca po przecinku.',
            rightSided: 'Prawostronne',
            shorteningDeviceUseTimeSpan: 'Skrócenie okresu użytkowania wyrobu medycznego',
            shorteningDeviceUseTimeSpanReason: {
               DISEASE: 'Jednostki chorobowe powodujące konieczność skrócenia okresu użytkowania wyrobu medycznego',
               PHYSICAL_DEVELOPMENT: 'Rozwój fizyczny',
               REHABILITATION: 'Rehabilitacja',
               SURGERY: 'Zabiegi chirurgiczne',
               label: 'Powód skrócenia okresu użytkowania',
            },
            shorteningDeviceUseTimeSpanTooltip: {
               firstListItem:
                  'u osób dorosłych w przypadkach zmian w stanie fizycznym powodujących konieczność skrócenia okresu użytkowania wyrobu medycznego, a możliwości regulacji tego wyrobu zostały wyczerpane;',
               prefixText:
                  'Okres użytkowania ulega skróceniu na podstawie jednego z poniższych kryteriów (wynikających z załącznika do rozporządzenia w sprawie wykazu wyrobów medycznych wydawanych na zlecenie):',
               secondListItem:
                  'u dzieci do 18. roku życia, gdy możliwości regulacji wyrobu zostały wyczerpane, a wystąpiły zmiany w stanie fizycznym w wyniku:',
               secondListItemFirstNest:
                  'zabiegów chirurgicznych lub jednostek chorobowych powodujących konieczność skrócenia okresu użytkowania wyrobu medycznego,',
               secondListItemSecondNest: 'rehabilitacji,',
               secondListItemThirdNest: 'rozwoju fizycznego;',
            },
            spectacleLenses: 'Soczewki okularowe',
            supplyMonthsCount: 'Liczba miesięcy zaopatrzenia',
            tillLimit: 'do limitu',
         },
         goBackToMedicalDeviceOrder: 'Wróć do widoku eZWM',
         goBackToVisit: 'Wróć do wizyty',
         goToNfzLogin: 'Przejdź do logowania NFZ',
         goToNfzSettings: 'Przejdź do ustawień NFZ',
         historicalMedicalDeviceOrder: {
            accusativePlural: 'm-ce',
            code: 'Kod',
            creationDate: 'Data utworzenia',
            denominatorSingle: 'm-c',
            device: 'Wyrób',
            documentNumber: 'Numer dokumentu',
            enterCodeOrDeviceName: 'Wpisz kod lub nazwę wyrobu...',
            genitivePlural: 'm-cy',
            goToNewOrder: 'Przejdź do zakładki "Nowe zlecenie" i uzupełnij formularz',
            noMatchingOrders: 'Brak pasujących zleceń',
            noOrdersIssued: 'Nie wystawiono żadnego zlecenia dla tego pacjenta',
            orderCorrection: 'Korekta zlecenia',
            orderDates: '{{firstSupplyDate}} przez {{supplyMonthsCount}} {{monthDeclension}}',
            orderStatus: {
               ACCEPTED: 'Zweryfikowane pozytywnie',
               CANCELLED: 'Anulowane',
               COMPLETED: 'Zrealizowane',
               PAPER: 'Papierowe',
               REJECTED: 'Zweryfikowane negatywnie',
               VERIFICATION: 'W trakcie weryfikacji',
            },
            status: 'Status',
            units: '{{count}} szt.',
            unitsPerMonth: '{{count}} szt./miesiąc',
            verifyAgain: 'Zweryfikuj ponownie',
         },
         identifiedError: 'Zidentyfikowany błąd:',
         linkName: 'eZWM',
         medicalDevicesSupplyOrder: 'Zlecenie na zaopatrzenie w wyroby medyczne',
         nfzConfigurationFailedSnackbarMessageForAdmin: 'Integracja z NFZ nie powiodła się. <link />',
         nfzConfigurationFailedSnackbarMessageForNonAdmin:
            'Integracja z NFZ nie powiodła się, skontaktuj się z administratorem.',
         nfzConfigurationMissingModalTextContentForAdmin:
            'Upewnij się, że w ustawieniach NFZ masz uzupełnione wszystkie wymagane dane oraz włączoną integrację z systemem eZWM.',
         nfzConfigurationMissingModalTextContentForNonAdmin:
            'Skontaktuj się z administratorem aby upewnić się, że w ustawieniach NFZ są uzupełnione wszystkie wymagane dane oraz jest włączona integracja z systemem eZWM.',
         nfzConfigurationMissingModalTitleWithPrint:
            'Integracja z NFZ nie powiodła się. Czy chcesz wydrukować zlecenie papierowe?',
         nfzConfigurationMissingModalTitleWithoutPrint: 'Integracja z NFZ nie powiodła się',
         nfzLoginFaultModalTitle: 'Nie udało się zalogować do NFZ. Czy chcesz wydrukować zlecenie papierowe?',
         nfzPasswordHasExpiredYouNeedToMakePasswordChange: 'Wygasło hasło do systemu NFZ, zmień hasło NFZ',
         ok: 'OK',
         orderStillInVerification: 'Weryfikacja zlecenia nie została ukończona. Spróbuj ponownie później',
         orderVerifiedNegatively: 'Zlecenie zostało zweryfikowane negatywnie',
         print: 'Drukuj',
         printWithoutVerification: 'Drukuj bez weryfikacji',
         printingDocument: 'Drukowanie zlecenia...',
         savingData: 'Zapisywanie danych...',
         sendEzwm: 'Wyślij eZWM',
         tabs: {
            newOrder: 'Nowe zlecenie',
            ordersHistory: 'Historia zleceń',
         },
         verifyingDocument: 'Weryfikacja dokumentu...',
      },
   },
};

export const medicalDevicesTranslationKeys = createScopedTranslationKeys(translations.pl, 'visit_medicalDevices');
